module.exports = __webpack_public_path__ + "static/media/icomoon.0be87366.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/icomoon/icomoon.woff?24fgiz
// module id = 2940
// module chunks = 0